import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationOverviewSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const FilterLevelThirdSelect = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.multiLocationOverview.availableFilters.level_3);
  const selectedOptions = useSelector((state) => state.multiLocationOverview.selectedLevelThird);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOptions}
      placeholder="Please Select"
      enableOnly
      numberDisplayed={0}
      includeSelectAll
      onSelectChange={(data) =>
        dispatch(actionCreators.updateFiltersRequest({ name: "FilterLevelThird", data: data }))
      }
    />
  );
};

export default FilterLevelThirdSelect;
